export default "__VITE_ASSET__CdZ7iARQ__"